import React, {useEffect, useImperativeHandle, useState} from "react";
import MultipleSelector from "@/components/MultipleSelector";
import { useTranslation } from "@/langs/useTranslation";
import CompanyDeviceApi from "@/apis/companyDeviceApi"
import localforage from 'localforage';

const TagList = React.forwardRef(
  (
    {
      disabled,
      name,
      value,
      onChange,
      clearable,
      // expandCompanies,
      className,
      style,
      currentGroup
    },
    ref
  ) => {
    const [tags,setTags] = useState([])
    const { t } = useTranslation();

    // const { data = { tags: [] }, run } = useRequest(() =>
    //   getAllTagsAPI(true, expandCompanies ? 1 : undefined)
    // );

    useEffect(()=>{
      LoadData()
    },[currentGroup])

    const LoadData = async () => {
      const user_company_id = await localforage.getItem("userCompanyID")
      const company_id = currentGroup ? currentGroup.id : null
      CompanyDeviceApi.GetCompanyTag(company_id ? company_id : user_company_id).then(res=>{
        setTags(res.tags)
      })
    }

    // useUpdateEffect(run, []);

    useImperativeHandle(ref, () => ({
      // getOptions: () => data.tags
    }));

    return (
      <MultipleSelector
        placeholder={t({ defaultMessage: "选择标签" })}
        options={tags}
        clearable={clearable}
        disabled={disabled}
        name={name}
        value={value}
        onChange={onChange}
        className={className}
        style={{ minWidth: 180, ...style }}
      />
    );
  }
);

export default TagList;
